import { Action } from "redux";
import { OrdersExcelSuccessPayload } from "./types";
import { OrdersExcelActionTypes } from "./types/actionTypes";

export interface fetchOrdersExcelInterface
  extends Action<OrdersExcelActionTypes> {
  type: OrdersExcelActionTypes.FETCH_ORDERS_EXCEL_SAGA;
  payload: { params: URLSearchParams };
}

export interface fetchOrdersExcelSuccessInterface
  extends Action<OrdersExcelActionTypes> {
  type: OrdersExcelActionTypes.FETCH_ORDERS_EXCEL_SUCCESS;
  payload: OrdersExcelSuccessPayload;
}

export interface resetOrdersExcelInterface
  extends Action<OrdersExcelActionTypes> {
  type: OrdersExcelActionTypes.RESET_ORDERS_EXCEL;
}

export const fetchOrdersExcel = (
  params: URLSearchParams
): fetchOrdersExcelInterface => {
  return {
    type: OrdersExcelActionTypes.FETCH_ORDERS_EXCEL_SAGA,
    payload: { params },
  };
};

export const fetchOrdersExcelSuccess = (
  payload: OrdersExcelSuccessPayload
): fetchOrdersExcelSuccessInterface => {
  return {
    type: OrdersExcelActionTypes.FETCH_ORDERS_EXCEL_SUCCESS,
    payload,
  };
};

export const resetOrdersExcel = (): resetOrdersExcelInterface => {
  return {
    type: OrdersExcelActionTypes.RESET_ORDERS_EXCEL,
  };
};

export type OrdersExcelActions =
  | fetchOrdersExcelInterface
  | fetchOrdersExcelSuccessInterface
  | resetOrdersExcelInterface;
